import React, { useState } from 'react';
import st from '../../style.module.scss';
import cx from './ReportsBusiness.module.scss';
import { Card, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Modals from '../../components/Modals/OrderModal';
import { GlobalState } from '../../store/global/global.slice';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export default function ReportsBusiness() {
  useDocumentTitle('GLOBAL.BUSINESS_REPORTS');
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState('');
  const handleShow = (modalname: string, status: boolean) => {
    console.log(modalname, status, 'handleShow');
    setModalName(modalname);
    setShow(status);
  };
  const handleClose = () => {
    setModalName('');
    setShow(false);
  };

  //Check the Language and Change the style
  const language = useSelector((state: { app: GlobalState }) => state.app?.language);
  const marginStyle = {
    marginLeft: language === 'en' ? '250px' : '0',
    marginRight: language === 'ar' ? '250px' : '0',
  };

  const { t } = useTranslation();

  return (
    <>
      <section className={`${language === 'en' ? `${st.pageWrapper}` : `${st.pageWrapperAr}`}`}>
        <div className={`${st.pageTitle}`}>
          <div className={`${st.pageTitleRow}`}>
            <div className={`${st.rowTitleLeft}`}>
              <h5>{t('GLOBAL.BUSINESS_REPORTS')}</h5>
            </div>
          </div>
        </div>

        <div className={`${st.pageWrapperInside}`}>
          <Card>
            <Card.Body className={`${cx.cardBody}`}>
              <Row>
                <Col lg={3}>
                  <NavLink to='/reports/business/taxes' className={`${cx.moreOption}`}>
                    {t('GLOBAL.TAXES')}
                  </NavLink>
                </Col>
                <Col lg={3}>
                  <NavLink to='/reports/business/tips' className={`${cx.moreOption}`}>
                    {t('GLOBAL.TIPS')}
                  </NavLink>
                </Col>
                {/* <Col lg={3}>
                  <NavLink
                    to="/reports/business/gift-cards"
                    className={`${cx.moreOption}`}
                  >
                    {t("GLOBAL.GIFT_CARD")}
                  </NavLink>
                </Col> */}
                <Col lg={3}>
                  <NavLink to='/reports/business/business-days' className={`${cx.moreOption}`}>
                    {t('GLOBAL.BUSINESS_DAYS')}
                  </NavLink>
                </Col>
                <Col lg={3}>
                  <NavLink to='/reports/business/shifts' className={`${cx.moreOption}`}>
                    {t('GLOBAL.SHIFTS')}
                  </NavLink>
                </Col>
                <Col lg={3}>
                  <NavLink to='/reports/business/tills' className={`${cx.moreOption}`}>
                    {t('GLOBAL.TILLS')}
                  </NavLink>
                </Col>
                <Col lg={3}>
                  <NavLink to='/reports/business/drawer-operations' className={`${cx.moreOption}`}>
                    {t('GLOBAL.DRAWER_OPERATIONS')}
                  </NavLink>
                </Col>
                <Col lg={3}>
                  <NavLink to='/reports/business/void-returns' className={`${cx.moreOption}`}>
                    {t('GLOBAL.VOIDS_AND_RETURNS')}
                  </NavLink>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </section>

      <Modals show={show} handleClose={handleClose} modalName={modalName} />
    </>
  );
}
